import { HammerGestureConfig, HammerModule, HAMMER_GESTURE_CONFIG, } from "@angular/platform-browser";
import {
  NgModule,
  Injectable,
  CUSTOM_ELEMENTS_SCHEMA,
  Injector,
  APP_INITIALIZER,
  LOCALE_ID
} from "@angular/core";

import { MAT_DATE_LOCALE } from '@angular/material/core';
import localeAr from '@angular/common/locales/ar';
import { HttpClient, HttpClientModule } from "@angular/common/http";

import { AppRoutingModule } from "./app-routing.module";

import { AppComponent } from "./app.component";
import { NgxSpinnerModule } from "ngx-spinner";
import { AsyncPipe, registerLocaleData, LocationStrategy, HashLocationStrategy } from "../../node_modules/@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { EventEmitterService } from "@shared/services/event-emitter.service";
import { ServiceLocator } from "@shared/services/locater.service";

export function tokenGetter() {
  return localStorage.getItem("token") || sessionStorage.getItem("token");
}
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/');
}

import { SharedDataService } from "@shared/services/shared-data.service";
export const configLookUp = (_configLookup: SharedDataService) => {
  return () => _configLookup
};
export const configCountries = (_configCountries: SharedDataService) => {
  return () => _configCountries
};
import { NgxImageCompressService } from "ngx-image-compress";
import { CoreModule } from "@core/core.module";


@Injectable()
export class CustomHammerConfig extends HammerGestureConfig {
  overrides = {
    pinch: { enable: true },
    rotate: { enable: true },
  };
}
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    HttpClientModule,

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      isolate: false
    }),

    NgxSpinnerModule,
    HammerModule,
  ],
  providers: [
    // Set the default locale and timezone for mat-datepicker
    { provide: LOCALE_ID, useValue: 'en-US' },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    NgxImageCompressService,
    EventEmitterService,
    { provide: HAMMER_GESTURE_CONFIG, useClass: CustomHammerConfig },
    AsyncPipe,
    {
      provide: APP_INITIALIZER,
      useFactory: configLookUp,
      deps: [SharedDataService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: configCountries,
      deps: [SharedDataService],
      multi: true,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private injector: Injector) {
    ServiceLocator.setInjector(this.injector);
    registerLocaleData(localeAr, 'ar');

  }
}
